import {Skeleton} from '@/shared/ui/components/skeleton';

export const MeasurementsSkeleton = () => (
  <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 pt-6 pb-8 sm:px-6 sm:pt-8">
    <Skeleton className="h-8 w-48" />
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <Skeleton className="h-28 w-full" />
      <Skeleton className="h-28 w-full" />
      <Skeleton className="h-28 w-full" />
      <Skeleton className="hidden h-28 w-full sm:block" />
      <Skeleton className="hidden h-28 w-full sm:block" />
      <Skeleton className="hidden h-28 w-full lg:block" />
    </div>
  </div>
);
